﻿import FormSubmissionEvent from '../datalayer/events/form-submission-event.js';
import applyValidationMessages from '../utility/validation-messages.js';
import formTracker from '../utility/form-event-tracker';

let configuratorContainer = null;
let formSelector;
let form = null;

const state = {
    name: '',
    telephone: '',
    email: '',
    postcode: '',
    isComplete: false,
    isWorking: false
};

const submitButton = document.getElementById('configurator-pdf-btn');
const submitButtonSpinner = document.getElementById('btn-submit-pdf-spinner');
const submitButtonText = document.getElementById('btn-submit-pdf-text');
const successAlert = document.getElementById('configurator-pdf-success');

export default {
    canInit: (selector) => {
        configuratorContainer = document.querySelector(selector);
        return configuratorContainer !== null;
    },
    canInitForm: (selector) => {
        form = document.querySelector(selector);
        formSelector = selector;
        return form !== null;
    },
    init: () => {
        window.addEventListener('load', () => {

            ExpiviComponent.default({
                catalogueId: 25594,
                viewerContainer: '#viewerContainer',
                optionContainer: '#optionsContainer',
                priceSelectors: '#priceContainer',
                currency: 'GBP',
                locale: 'en-GB',
                token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMTgyMTc4MjQ3NjE4ZDA1ZmZjYmUwNzJmYjM5YWY5ZjMxZDg1NWMyM2MyNWJjMzQ3ZWE4MTRkNDAyMGUzNmVmMDMzMjc0ZmQxOTY0YmMwZjQiLCJpYXQiOjE2OTAyOTI4OTguNjI3ODgyLCJuYmYiOjE2OTAyOTI4OTguNjI3ODg2LCJleHAiOjIwMDU5MTIwOTguMjQyMTYyLCJzdWIiOiIzNDI4Iiwic2NvcGVzIjpbXX0.BG7FVUEHPoR46H7AZC-UY1XpYSoy9hB7Pk8nFmIC8gTTOHEMHpuVMbPl993tkmt816z3vXEjbbafDmV1aeayYIA6frgT2pv3EhZGxFHFf1BLly8X9atB8hafuMrvkbVBPOqQ3-mDnyuHATIzI3qpftmkQFcGlzLSXYV0GxfBTIgXbA0yQ3mBnkS-j-nkdW_cH06u0X1llralnfzV_VQqsTaMZp4la9yV7Onci4-cstDpWdGUDizTE2DpWnGLw4xdj95RQsvdBdZ9YscExXIKTWu1iTLaP9RmUYav-7O3n9yADN-NFnYPxrpMVpmIaPModWmDMll4G_EP6r8yqfoZWdS35tT1m-uut18EJOJoouEcP2u85ii7k4kD9DbPUoM6OLnLF_in9CDJ6U-p6JPcJun5JYWSbg48eaE-jQraQIXiKhKJcHv4qG7TRWhbUOzs05oUbAc0EENjVpIKZ4iR5POfN2QJOOvHs_ghajrwVr8pcrlNySWtjA19laQ1aL7HjU_7zqzun4mffbVmFi_tJhjXXMiuzD0gmG9-z6kmGbHc9CLGkUbehwaZXNvgBib4d8JN6JGfer7KAPYaHyORvbg5J85bPFYPbAcQwpSrDG4HkdNWr1JwZjknpnCc71eyoBTQTQVX6y1zdP6OMAsbVeVFFzJPgmKwazVm4ym0Hk8',
                preset: ''
            });

            const expiviInterval = setInterval(() => {

                if (!window.expivi?._events?.onChange) {
                    return;
                }

                clearInterval(expiviInterval);

                window.expivi._events.onChange.subscribe((event) => {
                    if (event.name === 'product_finished_loading') {
                        enableButtons();
                    }
                });

            }, 100);

        });
    },
    initForm: () => {
        form.noValidate = true;
        form.addEventListener('submit', submitHandler);

        if (formTracker.canInit(formSelector)) {
            formTracker.init();
        }
    }
};

function submitHandler(e) {
    e.preventDefault();

    if (state.isWorking) return;

    applyValidationMessages(form);
    const isValid = form.reportValidity();

    pushDataLayer();

    if (!isValid) {

        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus();
        }

        return;
    }
    
    submitForm();
}

async function submitForm() {
    state.isWorking = true;

    submitButton.disabled = true;
    submitButtonSpinner.classList.remove('d-none');
    submitButtonText.textContent = 'Generating PDF...';
    successAlert?.classList.add('d-none');

    try {

        // generate reCAPTCHA token
        const recaptchaToken = await new Promise(function (resolve, reject) {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfC6-4tAAAAAN_jz9ln87vRaN6dXGduLeluXwnU', { action: 'configurator' })
                    .then(resolve)
                    .catch(reject);
            });
        });

        const configuration = await window.expivi.saveConfiguration(
            960,
            540,
            'FIRST_POSITION'
        );

        const formValues = getFormData();

        const payload = {
            customer: formValues,
            configuration,
            recaptchaToken
        };

        const response = await fetch(
            '/Configurator/trellus?handler=DownloadPdf',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }
        );

        if (!response.ok) {
            throw new Error(`Failed to download PDF (status ${response.status})`);
        }

        const blob = new Blob(
            [await response.blob()],
            {
                type: 'application/pdf'
            }
        );

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.download = 'configuration.pdf';

        document.body.appendChild(link);

        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

        document.dispatchEvent(
            new CustomEvent('trellus-config-pdf-downloaded')
        );

        successAlert?.classList.remove('d-none');

        form.reset();

    } finally {
        submitButton.disabled = false;
        submitButtonSpinner.classList.add('d-none')
        submitButtonText.textContent = 'Submit';

        state.isWorking = false;
    }
}

function enableButtons() {
    const pdfModalButton = document.querySelector('#btn-pdf-modal');

    if (pdfModalButton !== null) {
        pdfModalButton.disabled = false;
    }
}

function getFormData() {

    const priceText = document.querySelector('.price')?.textContent;

    return {
        name: document.querySelector('#Name')?.value,
        telephone: document.querySelector('#Telephone')?.value,
        email: document.querySelector('#Email')?.value,
        postcode: document.querySelector('#Postcode')?.value,
        price: priceText?.replace(/[£,\s]/g, ''),
        utmSource: sessionStorage.getItem('utm_source') || '',
        utmMedium: sessionStorage.getItem('utm_medium') || '',
        utmCampaign: sessionStorage.getItem('utm_campaign') || ''
    };
}

function pushDataLayer() {
    const errors = Array.from(form.elements)
        .filter(element => element.willValidate && !element.validity.valid)
        .map(element => ({
            message: element.validationMessage
        }));

    const dataLayerEvent = new FormSubmissionEvent('trellus_configurator_pdf', errors);
    dataLayerEvent.push();
}